const ACCESS_KEY = 'dentassist_access';
const REFRESH_KEY = 'dentassist_refresh';

export const getAccess = () => localStorage.getItem(ACCESS_KEY);
export const getRefresh = () => localStorage.getItem(REFRESH_KEY);

export const setTokens = (access, refresh) => {
  localStorage.setItem(ACCESS_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
};

export const setAccess = (access) => {
  localStorage.setItem(ACCESS_KEY, access);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};
